import { useUserStore } from "@/stores/UserStore";

export const allDashboards = (type) => {
  const myDash = getMyDashboards(type);
  const clientDash = getClientDashboards(type);
  const allDashboards = myDash.concat(clientDash);
  return allDashboards;
};

export const getMyDashboards = (type) => {
  const userStore = useUserStore();
  const currentUser = userStore.currentUser;
  const { tableau_workbooks } = currentUser ? currentUser : [];
  const links = [];
  for (const i in tableau_workbooks) {
    if (tableau_workbooks[i].dashboard_type === type) {
      if (links.length === 0) {
        links.push({ header: "My Dashboards" });
      }
      links.push({
        id: tableau_workbooks[i].id,
        url: tableau_workbooks[i].url,
        username: tableau_workbooks[i].username,
        text: tableau_workbooks[i].display_name,
      });
    }
  }
  return links;
};

export const getClientDashboards = (type) => {
  const userStore = useUserStore();
  const currentUser = userStore.currentUser;
  const { clients } = currentUser ? currentUser : [];
  const links = [];
  for (const i in clients) {
    for (const j in clients[i].tableau_workbooks) {
      if (clients[i].tableau_workbooks[j].dashboard_type === type) {
        const hasHeader = links.find((elem) => elem.header === clients[i].name);
        if (!hasHeader) {
          links.push({ header: clients[i].name });
        }
        links.push({
          id: clients[i].tableau_workbooks[j].id,
          url: clients[i].tableau_workbooks[j].url,
          username: clients[i].tableau_workbooks[j].username,
          text: clients[i].tableau_workbooks[j].display_name,
        });
      }
    }
  }
  return links;
};
